import { render, staticRenderFns } from "./WaitingView.vue?vue&type=template&id=74b2da0a&scoped=true&"
import script from "./WaitingView.vue?vue&type=script&lang=js&"
export * from "./WaitingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2da0a",
  null
  
)

export default component.exports